export default "__VITE_ASSET__B4RX0qpH__"